import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../services/AuthContext'

const AuthRedirect: React.FC = () => {
  const { user, subscription, loading } = useAuth()

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{ 
          background: 'white', 
          padding: '2rem', 
          borderRadius: '1rem', 
          boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          textAlign: 'center'
        }}>
          <div>Loading...</div>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Check if we have a redirect path stored (e.g., from upgrade flow)
  const redirect = localStorage.getItem('auth_redirect')
  if (redirect) {
    localStorage.removeItem('auth_redirect') // Clean up
    return <Navigate to={redirect} replace />
  }

  // If user has no subscription or is on free plan, redirect to subscribe
  if (!subscription || subscription.plan === 'free') {
    return <Navigate to="/subscribe" replace />
  }

  // If user has a paid subscription, redirect to account
  return <Navigate to="/account" replace />
}

export default AuthRedirect
